/**
 * PlatformCapabilities of the web runtime (contracts/platform.ts, web.md §2). Two facts depend on the
 * browser: `durableStorage` (false when OPFS is missing and the engine runs on an in-memory database) and
 * `onDeviceModels` (false when the tab cannot run the model worker: platform/model/support.ts).
 */

import type { PlatformCapabilities } from '@digester/core';

export function webCapabilities(durableStorage: boolean, onDeviceModels = false): PlatformCapabilities {
  return {
    runtime: 'web',
    unrestrictedFetch: false,
    relay: true,
    directImap: false,
    background: 'none',
    watcherFeeder: false,
    durableStorage,
    purchase: 'mock',
    onDeviceModels,
  };
}

/** A short device name for sync registration, e.g. "Chrome on Linux". */
export function webDeviceName(userAgent: string = globalThis.navigator?.userAgent ?? ''): string {
  const browser = /Edg\//.test(userAgent)
    ? 'Edge'
    : /Firefox\//.test(userAgent)
      ? 'Firefox'
      : /Chrome\/|Chromium\//.test(userAgent)
        ? 'Chrome'
        : /Safari\//.test(userAgent)
          ? 'Safari'
          : 'Browser';
  const os = /Android/.test(userAgent)
    ? 'Android'
    : /iPhone|iPad|iPod/.test(userAgent)
      ? 'iOS'
      : /Mac OS X|Macintosh/.test(userAgent)
        ? 'macOS'
        : /Windows/.test(userAgent)
          ? 'Windows'
          : /Linux|X11/.test(userAgent)
            ? 'Linux'
            : 'the web';
  return `${browser} on ${os}`;
}
